import { range } from '@firsttable/functions';
import { Box } from '@firsttable/web-components/atoms';

const ReviewsLoading = () => (
  <>
    {range(0, 9).map((i) => (
      <Box className="pulse-animation" key={`${i}_loading`}>
        <Box display={[null, 'flex']}>
          <Box
            mt={[-8, -6]}
            mb="18px"
            mr="24px"
            width={[32, 56]}
            height={[32, 56]}
            bg="grayscale.300"
            borderRadius="50%"
          />
          <Box flex={1}>
            <Box height={[12, 15]} mb={[10, 20]} maxWidth={170} bg="grayscale.300" />
            <Box height={[8, 10]} mb={[15, 25]} maxWidth={150} bg="grayscale.300" />
            <Box height={[15, 20]} maxWidth="90%" bg="grayscale.300" />
          </Box>
        </Box>
        <Box height={1} my={[30, 50]} bg="grayscale.300" />
      </Box>
    ))}
  </>
);

export default ReviewsLoading;
